var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitterX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M.046 0 7.47 9.928 0 18h1.682l6.54-7.067L13.506 18h5.721l-7.84-10.486L18.34 0h-1.682l-6.023 6.508L5.77 0H.047m2.472 1.239h2.628L16.753 16.76h-2.628z"
})));
export default SvgTwitterX;